<template>
  <v-app>
    <v-app-bar :color="color()" dense dark app v-if="show">
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <last-disaster />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="backHome()" v-bind="attrs" v-on="on">
            <v-icon>mdi-home</v-icon>
          </v-btn>
        </template>
        <span>トップ画面に戻る</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon href="/logout" v-bind="attrs" v-on="on">
            <v-icon>mdi-logout</v-icon>
          </v-btn>
        </template>
        <span>ログアウトする</span>
      </v-tooltip>
    </v-app-bar>
    <v-main>
      <bread-crumb v-if="show" />
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>
    <v-footer :color="color()" app v-if="show">
      <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from "vue";
import Disaster from "@/plugins/disaster";
import { DisasterClass } from "@/js/value-objects/disaster-class";
Vue.use(Disaster);
export default {
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb"),
    LastDisaster: () => import("@/components/LastDisaster")
  },
  data() {
    return {
      title: process.env.VUE_APP_HEADER_TITLE,
      show: true
    };
  },

  watch: {
    $route: "initialize"
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      // スマホアプリから表示される画面のため、ヘッダ＆フッタ、パンくずリストを非表示にする
      if (this.$route.path.startsWith("/car/register/app")) {
        this.show = false;
      }
      if (
        this.$route.name === "not-found" ||
        this.$route.name === "error" ||
        this.$route.name === "seamless-login" ||
        this.$route.name === undefined
      ) {        return;
      }
      if (this.$route.name !== "home" && !this.$screenAuthority) {
        this.$router.push("/");
      } else if (
        this.$route.name !== "home" &&
        this.$route.name !== "aggregation-menu" &&
        !this.$disaster
      ) {
        this.$router.push("/aggregation-menu");
      }
    },

    color() {
      if (this.$disaster && this.$disaster.disaster_cls === DisasterClass.T) {
        return "deep-orange darken-1";
      }
      return "indigo";
    },

    backHome() {
      this.$nextTick(() => {
        if (this.$route.path !== "/") {
          this.$router.push({ path: "/" });
        }
      });
    }
  }
};
</script>
